export const isNumeric = (value: unknown) => {
  if (typeof value === 'string') {
    return !Number.isNaN(Number(value));
  }
  return typeof value === 'number' && !Number.isNaN(value);
};
